import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const AdminLayout = () => {
  const location = useLocation();

  const isActive = (path: string) =>
    location.pathname === path
      ? "text-[#5c2f2f] font-semibold"
      : "text-[#a25d5d] hover:text-[#5c2f2f]";

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className="w-48 bg-[#fff0f0] pt-8 px-4 space-y-4 border-r border-[#e6cccc]">
        <h2 className="text-xl font-bold text-[#5c2f2f] mb-4">Admin</h2>

        <nav className="flex flex-col space-y-2">
          <Link to="/admin/brands" className={isActive("/admin/brands")}>
            Brands
          </Link>

          <Link to="/admin/banners" className={isActive("/admin/banners")}>
            Banners
          </Link>

          <Link to="/admin/products" className={isActive("/admin/products")}>
            Products
          </Link>

          <Link
            to="/admin/orderManagement"
            className={isActive("/admin/orderManagement")}
          >
            Order Management
          </Link>

          <Link to="/admin/offers" className={isActive("/admin/offers")}>
            Offers
          </Link>

          <Link to="/admin/attributes" className={isActive("/admin/attributes")}>
            Attributes
          </Link>
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
